module.exports = __webpack_public_path__ + "static/media/331.d52292b6.png";